import React from "react";

export default function useUsersLoad(loader, dispatch) {
  const [pending, setPending] = React.useState(true);
  const [error, setError] = React.useState("");
  const [revision, setRevision] = React.useState(0);
  React.useEffect(() => {
    let active = true;
    let received = false;
    setPending(true);
    setError("");
    // Some existing store functions return nothing on success. A dispatch
    // confirms that the list was received, including an empty list.
    Promise.resolve().then(() => loader((action) => {
      received = true;
      dispatch(action);
    }, { idClient: "" })).then(() => {
      if (!received) throw new Error("Data belum diterima");
    }).catch(() => {
      if (active) setError("Data pengguna belum dapat dimuat. Silakan coba lagi.");
    }).finally(() => {
      if (active) setPending(false);
    });
    return () => { active = false; };
  }, [loader, dispatch, revision]);
  return { pending, error, onRefresh: () => setRevision((value) => value + 1) };
}
